import { useState } from 'react';
import { toast } from 'react-toastify';
import { ArrowDownToLine, CirclePlus } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';

import { useSafeParams } from 'hooks';
import { useLazyGetDownloadPatientCardQuery } from 'store/api';

import { ADD_ESTIMATE, PDF } from '../../constants';

import { ClientBlankEstimateAdd } from './client-blank-estimate-add';

import styles from './styles.module.scss';

export const ClientBlankEstimateActions = ({ onAdd, isAdaptive, isMobile }: any) => {
	const [open, setOpen] = useState(false);
	const { clientId } = useSafeParams();

	const [patientCard] = useLazyGetDownloadPatientCardQuery();

	const handleDownload = async () => {
		if (clientId == null) {
			console.error('Некорректный идентификатор бланка:', clientId);
			return;
		}
		try {
			const blob = await patientCard(clientId).unwrap();
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${clientId}.pdf`);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (error) {
			console.error('Ошибка при скачивании бланка:', error);
			toast.error('Не удалось скачать бланк');
		}
	};

	return (
		<>
			{isAdaptive ? (
				<div className={styles.actions}>
					{isMobile ? (
						<Button size="l" onClick={handleDownload}>
							<Icon data={ArrowDownToLine} size={16} />
						</Button>
					) : (
						<Button size="l" onClick={handleDownload}>
							<Icon data={ArrowDownToLine} size={16} /> {PDF}
						</Button>
					)}
					<Button size="l" className={styles.actions__plus} onClick={() => setOpen(true)}>
						<Icon data={CirclePlus} size={16} />
						{ADD_ESTIMATE}
					</Button>

					<ClientBlankEstimateAdd open={open} setOpen={setOpen} onAdd={onAdd} />
				</div>
			) : (
				<div className={styles.actions}>
					<Button size="l" className={styles.actions__plus} onClick={() => setOpen(true)}>
						<Icon data={CirclePlus} size={16} />
						{ADD_ESTIMATE}
					</Button>
					<ClientBlankEstimateAdd open={open} setOpen={setOpen} onAdd={onAdd} />

					<Button size="l" onClick={handleDownload}>
						<Icon data={ArrowDownToLine} size={16} />
						{PDF}
					</Button>
				</div>
			)}
		</>
	);
};
